import React from 'react';
import { Dropdown, Menu, Button } from 'antd';
import { DownOutlined, UserOutlined } from '@ant-design/icons';


const LoggedIn = (props) => {

  const menu = (
    <Menu>
      <Menu.Item key="1" icon={<UserOutlined />} onClick={props.onGotoIntegrationGuide}>
        Integration guideline
      </Menu.Item>
      <Menu.Item key="2" icon={<UserOutlined />} onClick={props.onGoToApiDocViewer}>
        Go to API doc viewer
      </Menu.Item>
      <Menu.Item key="3" icon={<UserOutlined />} onClick={props.onSignOut}>
        Sign Out
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} style={{
      ...props.style
    }}
      overlayStyle={{
        zIndex: 99998
      }}
    >
      <Button>{props.user.name}<DownOutlined /></Button>
    </Dropdown>
  )
};

export default LoggedIn;